import styled from 'styled-components';
import { BpPlayListWrapper } from './components/PlayList/BpPlayListStyles';
import { BpLineupListWrapper } from './components/LineupList/BpLineupListStyles';
import { BpTaggingFlowWrapper } from './components/TaggingFlow/BpTaggingFlowStyles';
import { MetricsWrapper } from 'pages/Tagging/components/Metrics/MetricsStyles';

export const HeightWrapper = styled.div`
  height: 66vh;
  max-height: 575px;
  ${BpPlayListWrapper} {
    height: 100%;
  }
  ${BpLineupListWrapper} {
    height: 100%;
  }
  ${BpTaggingFlowWrapper} {
    height: 100%;
  }
  ${MetricsWrapper} {
    height: 100%;
  }
`;
